import service from '@/services'

export default {
  methods: {
    async printLaporanSales(params) {
      try {
        const config = {
          url: '/cetak-laporan-sales',
          method: 'get',
          params,
          responseType: 'blob',
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)
        return Promise.resolve(response)
      } catch (e) {
        if (e.response && e.response.data) {
          const blob = e.response.data
          if (blob instanceof Blob) {
            const text = await blob.text()
            try {
              return Promise.reject(JSON.parse(text))
            } catch (parseErr) {
              return Promise.reject(e)
            }
          }
        }
        return Promise.reject(e)
      }
    },
  },
}
